
import 'react-block-ui/style.css';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Button, Row, Col, Modal, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import BlockUi from 'react-block-ui';
import { TextArea } from 'devextreme-react';
import i18next from 'src/i18next';
import ChatsService from '../../controllers/ChatController';
import Toastr from 'src/components/utils/toastr';

const types = ["maintain", "formal", "friendly"];
const sizes = ["maintain", "short", "long"];

class AiResponse extends Component {

    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            currentText: "",
            size: "maintain",
            type: "maintain",
            response: ""
        }

        this.sizeChange = this.sizeChange.bind(this);
        this.typeChange = this.typeChange.bind(this);
        this.setResponse = this.setResponse.bind(this);
        this.setLoading = this.setLoading.bind(this);
        this.generateResponse = this.generateResponse.bind(this);
        this.currentTextChange = this.currentTextChange.bind(this);

        this.toastrRef = React.createRef();
    }

    setLoading(value) {
        this.setState({
            loading: value
        })
    }
    setCurrentText(value) {
        this.setState({
            currentText: value
        })
    }


    componentDidUpdate(prevProps, prevState) {
        if (prevProps.show === false && this.props.show) {
            this.setCurrentText(this.props.inputValue)
        }
    }

    sizeChange(e) {
        this.setState({
            size: e.target.value
        })
    }

    typeChange(e) {
        this.setState({
            type: e.target.value
        })
    }


    setResponse(value) {
        this.setState({
            response: value
        })
    }

    currentTextChange(e) {
        this.setState({
            currentText: e.event.currentTarget.value
        })
    }

    generateResponse() {
        let data = {
            guid: this.props.interaction.guid,
            language: i18next.language || window.localStorage.i18nextLng,
            size: this.state.size,
            type: this.state.type,
            draft: this.state.currentText
        };
        this.setLoading(true);
        ChatsService.getResponse(data, res => {
            console.log(res);
            if (res !== null && res.trim() !== "") {
                this.setResponse(res);
            } else {
                this.toastrRef.current.setType("error");
                this.toastrRef.current.setMessage(this.props.t("error"));
                this.toastrRef.current.show();

            }


            this.setLoading(false);

        })

    }

    setInputValue = e => {
        this.props.setInputValue(this.state.response);
        this.props.toggleModal();
    }
    render() {
        return (
            <>
                <Modal show={this.props.show} onHide={this.props.toggleModal} onShow={this.showModal} size="lg">
                    <BlockUi tag="div" blocking={this.state.loading} color="#009ef7" message={this.props.t("pleasewait")}>
                        <Modal.Header >
                            <Modal.Title><FontAwesomeIcon icon={duotone("sparkles")} /> {this.props.t("generateresponse")}</Modal.Title>
                            <OverlayTrigger
                                placement="left"
                                delay={{ show: 250, hide: 400 }}
                                overlay={<Tooltip style={{ position: "fixed" }}>
                                    {this.props.t("close")}
                                </Tooltip>}>
                                <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                            </OverlayTrigger>
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col>
                                    <TextArea
                                        label={this.props.t("writeabout")}
                                        value={this.state.currentText}
                                        onChange={this.currentTextChange}
                                    />
                                </Col>
                            </Row>
                            <Row className='mt-5 mb-5'>
                                <Col>
                                    <Form.Label>{this.props.t("tone")}</Form.Label>
                                    <Form.Select onChange={this.typeChange} value={this.state.type} >
                                        {
                                            types.map(elem => {
                                                return <option key={elem} value={elem} >{this.props.t(elem)}</option>
                                            })
                                        }
                                    </Form.Select>
                                </Col>
                                <Col>
                                    <Form.Label>{this.props.t("size")}</Form.Label>
                                    <Form.Select onChange={this.sizeChange} value={this.state.size} >
                                        {
                                            sizes.map(elem => {
                                                return <option key={elem} value={elem} >{this.props.t(elem)}</option>
                                            })
                                        }
                                    </Form.Select>
                                </Col>
                                <Col>
                                    <Button variant="primary" onClick={this.generateResponse} className='mt-8'>
                                        {this.props.t("generatedraft")}
                                    </Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <TextArea
                                        label={this.props.t("preview")}
                                        value={this.state.response}
                                        minHeight={100}
                                    />
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" onClick={this.setInputValue}>
                                <FontAwesomeIcon icon={duotone("paper-plane-top")} /> {this.props.t("ok")}
                            </Button>
                        </Modal.Footer>
                    </BlockUi>
                </Modal>
                <Toastr ref={this.toastrRef} />
            </>)
    }
}
const mapStateToProps = (state) => {
    return {
        interaction: state.interaction.current
    };
};
export default compose(connect(mapStateToProps, {}), withTranslation())(AiResponse);